/**
 * Applies `vector-effect: non-scaling-stroke` to all descendant SVG elements.
 *
 * Icons use `stroke-width: 1.5` at a native 24×24 viewBox. When rendered at any
 * other size the browser scales the stroke along with the geometry, making it
 * visually thicker or thinner. This class keeps the stroke at its specified pixel
 * width regardless of how the icon is scaled.
 *
 * Safe to apply to fill-only icons — it is a no-op when no stroke is present.
 *
 * @example
 * // Direct icon import
 * import { iconStrokeFix } from "@ui/central-icons/iconUtils";
 * <IconArrowDown className={cn(iconStrokeFix, "tw-size-4")} />
 */
export const iconStrokeFix = "[&_*]:[vector-effect:non-scaling-stroke]";
